import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const RegionMapPage = () => {
    const { t } = useTranslation();
    return (
        <div>
            <Helmet>
                <title>{`APFM | ${t("REGION_MAP")}`}</title>
            </Helmet>
            <iframe
                title="الخريطة العربية"
                className="h-screen w-full"
                src="https://gis.aidmo.org/portal/apps/webappviewer/index.html?id=8ec7ff8605e046459da6ac0643c3f440"
            ></iframe>
        </div>
    );
};

export default RegionMapPage;






// import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";

// const RegionMapPage = () => {
//   const { t, i18n } = useTranslation();

//   // GET LANG FROM URL
//   const searchParams = new URLSearchParams(window.location.search);
//   const lang = searchParams.get("lang");

//   if (lang && lang !== i18n.language) {
//     i18n.changeLanguage(lang);
//   }

//   const message =
//     i18n.language === "ar"
//       ? "الخريطة في طور التحديث"
//       : "The map is being updated";

//   return (
//     <div className="flex h-screen w-full items-center justify-center bg-gray-100 px-4 text-center">
//       <Helmet>
//         <title>{`APFM | ${t("REGION_MAP")}`}</title>
//       </Helmet>

//       <div className="rounded-xl bg-white p-8 shadow-lg border border-gray-200">
//         <h1 className="text-2xl font-bold text-gray-700">
//           {message}
//         </h1>
//         <p className="mt-2 text-gray-500">
//           {i18n.language === "ar"
//             ? "يرجى العودة لاحقاً"
//             : "Please check back later"}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default RegionMapPage;






